import React from 'react';
import { Link } from 'react-router-dom';

function Cloud() {
  return (
    <div className="container text-light mt-5 px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="mb-3 text-white text-center">
          <i className="bi bi-cloud-check-fill me-2 text-info"></i>
          Soluções em Nuvem
        </h2>

        <p className="text-white-50 text-center mb-4">
          Transforme sua infraestrutura com soluções em nuvem seguras, escaláveis e de alta disponibilidade. A <strong>InfoService</strong> gerencia todo o processo de migração, operação e suporte.
        </p>

        <ul className="text-light fs-6">
          <li className="mb-3">
            <i className="bi bi-cloud-upload-fill me-2 text-primary"></i>
            <strong>Backup em nuvem:</strong> Armazenamento criptografado com versionamento, retenção e recuperação sob demanda.
          </li>

          <li className="mb-3">
            <i className="bi bi-server me-2 text-success"></i>
            <strong>Hospedagem de aplicações:</strong> Servidores virtuais otimizados, alta performance e suporte 24/7.
          </li>

          <li className="mb-3">
            <i className="bi bi-envelope-at-fill me-2 text-warning"></i>
            <strong>E-mail corporativo:</strong> Plataformas modernas com segurança, sincronização multi-dispositivo e domínio personalizado.
          </li>

          <li className="mb-3">
            <i className="bi bi-boxes me-2 text-danger"></i>
            <strong>Integrações:</strong> Soluções em Microsoft Azure, Amazon AWS, Google Cloud, com automação e escalabilidade.
          </li>
        </ul>

        <div className="mt-4 text-center">
          <Link to="/contato" className="btn btn-outline-info btn-lg px-4">
            Solicitar análise de migração
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Cloud;
